<template>
  <div id="ManagementPanel" :class="{ active: view, close: !view }">
    <MyLoading :viewLoader="viewLoader" type="" />
    <div class="mdl-grid" v-if="viewLoader">
      <div
        class="mdl-cell mdl-cell--1-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
      >
        <span class="material-icons closePanel" @click="closePanel()"
          >close</span
        >
      </div>
      <div
        class="mdl-cell mdl-cell--11-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
      >
        <h3 v-if="form.id">
          {{ $t("users.titleEditUser") }} {{ form.first_name }}
          {{ form.last_name }}
        </h3>
        <h3 v-else>{{ $t("users.titleNewUser") }}</h3>
        <p class="subTitle" v-if="form.id">
          {{ $t("users.subTitleEditUser") }}
        </p>
        <p class="subTitle" v-else>{{ $t("users.subTitleNewUser") }}</p>

        <div class="space"></div>

        <div class="mdl-grid noMargin">
          <div class="mdl-cell mdl-cell--12-col">
            <span class="labelTwo">{{ $t("users.sectionOne") }}:</span>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="cdl-input">
              <input
                type="text"
                name="first_name"
                v-model="form.first_name"
                @input="label($event)"
              />
              <label>{{ $t("users.nameUser") }}*</label>
              <span
                class="error"
                v-if="
                  this.v$.form.first_name.$invalid &&
                  this.v$.form.first_name.$dirty
                "
              >
                {{ $t("users.nameUser") }} {{ $t("checkCoverage.isRequired") }}
              </span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="cdl-input">
              <input
                type="text"
                name="last_name"
                v-model="form.last_name"
                @input="label($event)"
              />
              <label>{{ $t("users.surNameUser") }}*</label>
              <span
                class="error"
                v-if="
                  this.v$.form.last_name.$invalid &&
                  this.v$.form.last_name.$dirty
                "
              >
                {{ $t("users.surNameUser") }}
                {{ $t("checkCoverage.isRequired") }}
              </span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="cdl-input">
              <input
                type="text"
                name="email"
                v-model="form.email"
                @input="
                  label($event);
                  ctrlIdExists();
                "
                :disabled="form.id ? true : false"
              />
              <label>{{ $t("users.emailUser") }}*</label>
              <span
                class="error"
                v-if="this.v$.form.email.$invalid && this.v$.form.email.$dirty"
              >
                {{ $t("users.emailUser") }} {{ $t("checkCoverage.isRequired") }}
              </span>
              <span class="error" v-if="this.errorEmailSame">
                {{ $t("users.errorEmailSame") }}
              </span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="cdl-input">
              <input
                type="text"
                name="phone"
                v-model="form.phone"
                @input="label($event)"
              />
              <label>{{ $t("users.phoneUser") }}*</label>
              <span
                ><i>{{ $t("users.exPhoneUser") }}</i></span
              ><br />
              <span
                class="error"
                v-if="this.v$.form.phone.$invalid && this.v$.form.phone.$dirty"
              >
                {{ $t("users.phoneUser") }} {{ $t("checkCoverage.isRequired") }}
              </span>
              <span class="error" v-else-if="this.errorPhoneRegex">
                {{ $t("users.phoneUser") }} {{ $t("users.notFormat") }}
              </span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <p style="margin-top: 20px">
              <input
                type="checkbox"
                @change="checkMaintenance($event)"
                class="check"
                id="checkMaintenance"
                v-model="form.maintenance_on_primary_email"
              />
              <span
                class="emailTwoCheck"
                v-html="$t('users.maintenanceCheck')"
              ></span>
            </p>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="cdl-input">
              <input
                type="text"
                name="secondary_email"
                v-model="secondary_email"
                @input="label($event)"
              />
              <label
                >{{ $t("users.emailTwoUser") }}
                {{
                  maintenance_notification_use_secondary_email == true
                    ? "*"
                    : ""
                }}</label
              >
              <span
                class="error"
                v-if="
                  this.v$ &&
                  this.v$.secondary_email &&
                  this.v$.secondary_email.$invalid &&
                  this.v$.secondary_email.$dirty
                "
                >{{ $t("users.emailTwoUser") }}
                {{ $t("checkCoverage.isRequired") }}</span
              >
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col"></div>
          <div class="mdl-cell mdl-cell--12-col">
            <p style="margin-top: 20px">
              <input
                type="checkbox"
                @change="check($event)"
                class="check"
                id="check"
                ref="checkSecondEmailMaintenance"
                v-model="maintenance_notification_use_secondary_email"
              />
              <span
                class="emailTwoCheck"
                v-html="$t('users.emailTwoCheck')"
              ></span>
            </p>
<div class="mdl-cell mdl-cell--12-col" v-if="!form.id && isColocation">
              <hr />
            </div>
            <p v-if="!form.id && isColocation">

              <input
                type="checkbox"
                @change="check($event)"
                class="check"
                id="checkBiometric"
                ref="checkBiometricUser"
                v-model="form.is_biometric"
                aria-describedby="biometricNote"
              />

              <span
                class="emailTwoCheck"
                v-html="$t('users.userBiometricEnabled')"
              >
              </span>
            </p>
            <p
              v-if="!form.id && isColocation"
              id="biometricNote"
              class="text-sm text-gray mt-2"
              v-html="$t('users.userBiometricNote')"
            ></p>
            </div>
            </div>
          <div class="mdl-cell mdl-cell--12-col" >
            <hr />
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <span class="labelTwo">{{ $t("users.sectionTwo") }}</span>
            <p class="subSectionTwo">{{ $t("users.subSectionTwo") }}</p>
            <span
              class="error"
              v-if="
                this.v$.form.role_id.$invalid && this.v$.form.role_id.$dirty
              "
            >
              {{ $t("users.sectionTwo") }} {{ $t("checkCoverage.isRequired") }}
            </span>
          </div>
          <div class="mdl-cell mdl-cell--12-col contentGroupUser">
            <div
              v-for="(group, groupKey) in groups"
              :key="groupKey"
              class="groupName"
              :id="['group-' + groupKey]"
              :class="[
                getClassGroup(group),
                'groupColor-' + getColorRole(group.color.toLowerCase()),
                'group-' + group.id,
              ]"
              @click="setGroup(group)"
            >
              <div class="buttonRadio"></div>
              <div>{{ group.name }}</div>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <p class="textNewRole">{{ $t("users.newRole") }}</p>
            <div class="contentButton">
              <button class="cdlButton" @click="newRole" style="width: 100%">
                {{ $t("users.btnNewRole") }}
              </button>
            </div>
            <div class="space"></div>
            <hr />
            <div class="space"></div>
            <div class="contentButton">
              <button class="cdlButtonGreen" @click="submit" id="submitUser">
                {{
                  form.id ? $t("users.subTitleEditUser") : $t("users.saveUser")
                }}
              </button>
            </div>
            <p class="cancel" id="closeTab" @click="closePanel()">
              {{ $t("users.cancel") }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <StatusAlert v-if="viewError" status="error" role="alert">
      <template #body>
        <p>{{ messageError }}</p>
      </template>
    </StatusAlert>

</template>

<script>
import "@/assets/scss/ManagementPanel.scss";
import {useVuelidate} from "@vuelidate/core";
import {email, integer, required} from "@vuelidate/validators";
import MyLoading from "@/components/MyLoading.vue";
import StatusAlert from "@/components/Primitives/Alerts/StatusAlert.vue";
import {useUserStore} from "@/stores/UserStore";

const createDefaultForm = () => ({
  id: null,
  first_name: null,
  last_name: null,
  email: null,
  role_id: null,
  phone: null,
  maintenance_on_primary_email: false,
  marketing_on_primary_email: false,
  enabled: true,
  contacts: [],
  secondary_email: null,
  is_biometric: false,
});

export default {
  name: "MyManagementUser",
  // props: ['view', 'user'],
  components: {
    MyLoading,
    StatusAlert,
  },
  props: {
    view: {
      type: Boolean,
      required: true,
    },
    singleUser: {
      type: Object,
      required: true,
    },
    groups: {
      type: Object,
      required: true,
    },
    allUsers: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    let myValidate = {
      form: {
        first_name: { required },
        last_name: { required },
        email: { required, email },
        phone: { required },
        role_id: { required, integer },
      },
      secondary_email: { email },
    };

    if (this.maintenance_notification_use_secondary_email === true) {
      myValidate.secondary_email = { required, email };
    }
    return myValidate;
  },
  data() {
    return {
      viewLoader: true,
      form: createDefaultForm(),
      secondary_email: null,
      maintenance_notification_use_secondary_email: false,
      viewError: false,
      messageError: "",
      errorPhoneRegex: false,
      errorEmailSame: false,
      if_I: false,
      hasColocation : false
    };
  },
    computed: {
    isColocation() {
      return useUserStore().user.isColocation;
    },
  },
  async mounted() {
      // this.getIsAdmin();
      let he = {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      };

      const colocationResp = await this.checkColocationAccess(he);
      console.log(colocationResp)
      if(colocationResp){
        this.hasColocation=true
      }else{
        this.hasColocation=false
      }
  },
  methods: {
    async checkColocationAccess(headers) {
      try {
        const response = await this.axios.get(
          window.VUE_APP_MISTRA_URL +
            "assets/v1/has-assets/colocation",
          { headers }
        );

        const hasAssets = !!(response?.data?.hasAssets);

        if (!hasAssets) {
          this.forbiddenMessage = this.$t("noSolutionsServices.colocation");
        }

        return hasAssets;
      } catch (error) {
        const status = error?.response?.status ?? error?.request?.status;

        if (status === 403) {
          this.forbiddenMessage = this.$t("noSolutionsServices.colocation");
          return false;
        }

        console.error("Error checking colocation assets:", error);
        return true;
      }
    },
    closePanel(whoUpdate = 0) {
      this.$emit("close-panel", { whichPanel: 0, whoUpdate: whoUpdate });
    },
    regexPhone() {
      return /^\+?\d+$/.test(this.form.phone);
    },
    async submit() {
      const result = await this.v$.$validate();
      if (result && !this.errorEmailSame) {
        this.v$.$reset();
        // this.viewLoader = false;

        // Controllo telefono
        let isphone = this.regexPhone();

        this.errorPhoneRegex = false;

        if (!isphone) {
          this.viewLoader = true;
          this.errorPhoneRegex = true;
          return;
        }

        let he = {
          Accept: "application/json",
          Authorization: "Bearer " + this.$keycloak.idToken,
        };

        const self = this;

        // this.form.maintenance_on_primary_email = true;
        if (!this.form.maintenance_on_primary_email) {
          this.form.maintenance_on_primary_email = false;
        }

        this.form.marketing_on_primary_email = false;

        // Clear contacts array
        this.form.contacts = [];

        // Add secondary email to contacts if it exists
        if (this.secondary_email) {
          this.form.contacts.push({
            type: "secondary_email",
            name: "Secondary Email",
            value: this.secondary_email,
            maintenance_notification: this.maintenance_notification_use_secondary_email,
            marketing_notification: false
          });
        }
        this.form.is_biometric = !!this.form.is_biometric;

        const payload = JSON.parse(JSON.stringify(this.form));
        const biometricValue = (() => {
          if (payload && typeof payload.biometric === "object") {
            if (
              Object.prototype.hasOwnProperty.call(payload.biometric, "is_bio")
            ) {
              return payload.biometric.is_bio;
            }
            return payload.biometric;
          }
          if (typeof payload.biometric !== "undefined") {
            return payload.biometric;
          }
          return payload.is_biometric;
        })();

        payload.biometric = !!biometricValue;
        delete payload.is_biometric;

        // console.log(this.form);

        if (this.form.id) {
          let url = "users/v2/user/" + this.form.id;
          if (this.if_I) {
            url = "base/v2/user-info";
          }
          this.axios
            .put(
              window.VUE_APP_MISTRA_URL + url,
              payload,
              { headers: he }
            )
            .then(() => {
              this.viewLoader = true;

              const userStore = useUserStore();
              if (userStore.user.email == this.form.email) {
                userStore.setUser();
              }

              this.closePanel(1);
            })
            .catch(function (err) {
              console.log(err);
              self.viewError = true;
              self.viewLoader = true;
              self.messageError = err.message;
              self.resetLabel();
              setTimeout(() => {
                self.viewError = false;
              }, 5000);
            });
        } else {
          this.form.enabled = true;

          this.axios
            .post(
              window.VUE_APP_MISTRA_URL + "users/v2/user",
              payload,
              { headers: he }
            )
            .then(() => {
              this.viewLoader = true;
              this.closePanel(1);
            })
            .catch(function (err) {
              console.log(err);
              self.viewError = true;
              self.viewLoader = true;
              self.messageError = err.message;
              self.resetLabel();
              setTimeout(() => {
                self.viewError = false;
              }, 5000);
            });
        }
      }
    },
    label(ev) {
      this.$LabelInput(ev);
    },
    check(ev) {
      console.log(ev);
      // if (ev.currentTarget.checked) {
      //   this.maintenance_notification_use_secondary_email =
      //     ev.currentTarget.checked;
      //   if (document.getElementById("checkMaintenance").checked) {
      //     document.getElementById("checkMaintenance").click();
      //   }
      // }
    },
    checkMaintenance(ev) {
      console.log(ev);
      // if (ev.currentTarget.checked) {
      //   this.maintenance_on_primary_email = ev.currentTarget.checked;
      //   if (document.getElementById("check").checked) {
      //     document.getElementById("check").click();
      //   }
      // }
    },
    newRole() {
      this.$emit("open-role", this.form);
    },
    getClassGroup(groupSelected) {
      if (
        this.singleUser.role &&
        groupSelected.id == this.singleUser.role.id
      ) {
        return "active";
      }
      return "";
    },
    setGroup(groupSelected) {
      this.form.role_id = groupSelected.id;
      this.resetGroups();
      if (document.getElementsByClassName("group-" + this.form.role_id)[0]) {
        document
          .getElementsByClassName("group-" + this.form.role_id)[0]
          .classList.add("active");
      }
    },
    resetGroups() {
      let allGroups = document.getElementsByClassName("groupName");
      for (let i = 0; i < allGroups.length; i++) {
        allGroups[i].classList.remove("active");
      }
    },
    resetLabel() {
      let allInputs = document.getElementsByTagName("input");
      setTimeout(() => {
        for (let i = 0; i < allInputs.length; i++) {
          if (allInputs[i].value != "") {
            allInputs[i].classList.add("not-empty");
          }
        }
      }, 500);
    },
    ctrlIdExists() {
      this.errorEmailSame = false;
      this.allUsers.forEach((user) => {
        if (user.email == this.form.email) {
          this.errorEmailSame = true;
        }
      });
    },
    getColorRole(color) {
      return color != "" ? color : "6585a7";
    },
  },
  watch: {
    singleUser: {
      handler(newValue, oldValue) {
        // console.log(newValue.secondary_email, oldValue.secondary_email);
        this.if_I = false;
        this.errorPhoneRegex = false;
        if (Object.keys(newValue).length == 0) {
          Object.assign(this.form, createDefaultForm());
          this.secondary_email = null;
          this.maintenance_notification_use_secondary_email = false;
          this.form.contacts = [];
          Object.assign(this.form, createDefaultForm());
          this.secondary_email = null;
          this.maintenance_notification_use_secondary_email = false;
          this.form.contacts = [];
          this.resetGroups();
        } else {
          this.resetLabel();
          if (newValue.id != oldValue.id) {
            Object.assign(this.form, newValue);

            // Extract secondary_email and maintenance_notification from contacts if they exist
            this.secondary_email = null;
            this.maintenance_notification_use_secondary_email = false;
            this.maintenance_notification_use_secondary_email = false;

            if (this.form.contacts && this.form.contacts.length > 0) {
              const secondaryEmailContact = this.form.contacts.find(contact => contact.type === "secondary_email");
              if (secondaryEmailContact) {
                this.secondary_email = secondaryEmailContact.value;
                this.maintenance_notification_use_secondary_email = secondaryEmailContact.maintenance_notification;
              }
            }

            if (this.form.phone) {
              this.form.phone = this.form.phone
                .replace("+", "")
                .replace(" ", "");
            }

            this.form.secondary_email = newValue.secondary_email;

            this.setGroup(newValue.role);
          }
          let userStore = useUserStore();
          if (userStore.user.email == this.form.email) {
            this.if_I = true;
          }
        }
      },
      deep: true,
    },
  },
};
</script>
